import { createContext as t } from "react";
import s from "fuse.js";
const e = () => {
}, o = t({
  selectedItems: [],
  setSelectedItems: e,
  //
  isOpen: !1,
  setIsOpen: e,
  //
  isError: !1,
  //
  query: "",
  setQuery: e,
  useLocalSearch: !0,
  setUseLocalSearch: e,
  searchResults: [],
  setSearchResults: () => {
  },
  searchInstance: new s([]),
  //
  searchRef: { current: null },
  listRef: { current: null },
  //
  resource: "item",
  plurality: "s",
  allowMultiple: !0,
  disabled: !1
}), a = t({
  value: "",
  isSelected: !1
});
export {
  o as ComboboxContext,
  a as ComboboxItemContext
};
